// extracted by css-extract-rspack-plugin
export default {"optionTextWrapper":"option-text-wrapper--MS72_ipmaAARilLf"};